import React from 'react';
import { Translate, useLang, useTranslation } from '../../../config/TranslationProvider';
import config from '../../../config/config';
import Menu from '../Menu';

const Footer = () => {
    const {lang} = useLang();
    const {links, images} = config;

    const tmgsLogoAltText = useTranslation('tmgsLogoAltText');

    return (
        <>
            <footer className="footer-three footer-dark p-top-95">
                <div className="footer-top p-bottom-25">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="widget widget_pages">
                                    <h2 className="widget-title">
                                        <Translate value="service" />
                                    </h2>
                                    <ul className="list-unstyled">
                                        <Menu links={links.footer} pos="footer" />
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="widget widget_social">
                                    <h2 className="widget-title">
                                        <Translate value="search" />
                                    </h2>
                                    <ul className="list-unstyled social-list">
                                        {Object.values(links.socialMedia).map((value, key) => (
                                            <li key={key}>
                                                <a href={value.href}
                                                    rel="noopener noreferrer"
                                                    target={value.target}
                                                    aria-label={value.title}
                                                >
                                                    <span className={value.title.toLowerCase()}>
                                                        <i className={value.icon} />
                                                    </span> {value.title}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="footer-bottom--content">
                                    <a href="https://www.sachsen-tourismus.de/" className="footer-logo">
                                        <img
                                            src={images.logos.footer[lang]}
                                            loading="lazy"
                                            width="300"
                                            height="51"
                                            alt={tmgsLogoAltText}
                                        />
                                    </a>
                                    <p className="m-0 copy-text">
                                        <Translate value="copyright" />
                                    </p>
                                    <ul className="list-unstyled lng-list" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
